import { BarChart3, ChartSpline, Home, Radio, UserRound } from "lucide-react";
import { NavLink } from "../router";
import type { ReactNode } from "react";
import { useLanguage } from "../state/language";

export function AppShell({ children }: { children: ReactNode }) {
  const { t } = useLanguage();
  const left = [
    { to: "/", label: t("home"), icon: Home },
    { to: "/signals", label: t("signals"), icon: Radio },
  ];
  const right = [
    { to: "/analytics", label: t("analytics"), icon: BarChart3 },
    { to: "/profile", label: t("profile"), icon: UserRound },
  ];
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        {t("skipContent")}
      </a>
      <main id="main-content" className="app-main">
        {children}
      </main>
      <nav className="bottom-nav" aria-label={t("primaryNavigation")}>
        {left.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <Icon size={20} strokeWidth={1.9} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
        <NavLink
          to="/analysis"
          className={({ isActive }) => `nav-fab ${isActive ? "active" : ""}`}
          aria-label={t("analysis")}
        >
          <ChartSpline size={26} strokeWidth={2} aria-hidden="true" />
        </NavLink>
        {right.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <Icon size={20} strokeWidth={1.9} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
